import React from 'react'
import defailtTopicImg from '../../images/discussion-topic-hero.jpg'
import defaultQuestionImg from '../../images/discussion-question-img.jpg'
import DiscussionTopicMeta from './discussion-topic-meta'
import QuestionMeta from './question-meta'
import { Link } from 'react-router-dom'
import ServerImage from '../server-image'
import { compose } from 'redux'
import { withTranslations } from '../../decorators/with-translations'
import { withRouter } from 'react-router'
import Button from '../ui/button'
import styled from 'styled-components'
import BubbleMaskImg from '../../images/speech-bubble-mask.svg';
import { PHONELG, TABLET, LAPTOP, DESKTOP } from '../../utilities/breakpoints'

const QuestionBlock = ({question, useTranslate, closed}) => {

  return (
    <Question className={`${(closed || !question.active) ? "closed" : ""}`}>
      <QuestionImage>
        <div className="img-wrapper">
          {question.image ? (
            <ServerImage image={question.image}>
              {({ uri }) => (
                <img className="nav-logo" src={uri} alt="" />
              )}
            </ServerImage>
          ) : (
            <img src={defaultQuestionImg} alt="People"/>
          )}
        </div>
      </QuestionImage>
      <QuestionContent>
        <h3>{question.title}</h3>
        <QuestionMeta
          commentAmount={question.answersCount}
          useTranslate={useTranslate}
        />
      </QuestionContent>
    </Question>
  )
}

const DiscussionTopicBlock = ({
  closed,
  title,
  questions,
  toDiscussionTopic,
  image,
  useTranslate,
}) => {

  const t = (phrase) => useTranslate(`discussion.${phrase}`)

  return (
    <TopicPanel className={`topic-panel ${closed ? "closed" : ""}`}>
      {!closed &&
        <TopicImage>
          <div className="img-wrapper">
            {image ? (
              <ServerImage image={image}>
                {({ uri }) => (
                  <img src={uri} alt="Topic" />
                )}
              </ServerImage>
            ) : (
              <img src={defailtTopicImg} alt="Topic"/>
            )}
          </div>
        </TopicImage>
      }
      <TopicContent>
        <TopicHeader>
          <div>
            <h2>{title}</h2>
            <DiscussionTopicMeta
              closed={closed}
              questions={questions}
              useTranslate={useTranslate}
            />
          </div>
          <Button as={Link} to={toDiscussionTopic} size={"md"} className={"btn-topic"}>
            {closed ? t("view_closed_topic") : t("view_topic")}
          </Button>
        </TopicHeader>
        <TopicQuestions>
          {questions.map((question, index) => (
            <QuestionBlock question={question} useTranslate={useTranslate} key={index} closed={closed} />
          ))}
        </TopicQuestions>
        <Button as={Link} to={toDiscussionTopic} size={"md"} className={"btn-topic-mobile"}>
          {t("view_topic")}
        </Button>
      </TopicContent>
    </TopicPanel>
  )
}

export default compose(
  withRouter,
  withTranslations,
)(DiscussionTopicBlock);

const TopicPanel = styled.div`
  background-color: #fff;
  padding: 1rem;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  
  @media${TABLET} {
    padding: 1.5rem;
    flex-direction: row;
  }
  
  @media${LAPTOP} {
    padding: 2rem;
  }
  
  @media${DESKTOP} {
    padding: 2.5rem;
  }
`;

const TopicImage = styled.div`
  margin-bottom: 1rem;
  max-width: 400px;
  
  .img-wrapper {
    width: 100%;
    position: relative;
    padding-bottom: 65%;
    height: 0;
    border-radius: 20px;
    overflow: hidden;
    
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  
  @media${TABLET} {
    max-width: none;
    flex: 0 1 40%;
    margin-right: 15px;
    margin-bottom: 0;
    
    .img-wrapper {
      padding-bottom: 84.48%;
      mask-image: url(${BubbleMaskImg});
      mask-size: 100% 100%;
    }
  }
  
  @media${LAPTOP} {
    margin-right: 30px;
  }
  
  @media${DESKTOP} {
    flex: 0 0 348px;
    margin-right: 45px;
  }
`;

const TopicContent = styled.div`
  .btn-topic {
    display: none;
  }
  
  @media${TABLET} {
    flex: 1 1 100%;
    
    .btn-topic {
      display: block;
    }
    .btn-topic-mobile {
      display: none;
    }
  }
`;

const TopicQuestions = styled.div`
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  
  @media${TABLET} {
    gap: 20px;
    margin-bottom: 0;
  }
`;

const TopicHeader = styled.div`
  width 100%;
  margin-bottom: 20px;
  
  h2 {
    font-size: 22px;
  }
  
  .closed & {
    h2 {
      font-size: 20px;
    }
  }
  
  @media${TABLET} {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    
    h2 {
      font-size: 24px;
    }
    
    .closed & {
      h2 {
        font-size: 22px;
      }
    }
  }
  
  @media${LAPTOP} {
    margin-bottom: 25px;
    
    h2 {
      font-size: 30px;
    }
    .closed & {
      h2 {
        font-size: 24px;
      }
    }
  }
`;

const Question = styled.div`
  display: flex;
  align-items: center;
  
  .closed & {
    background-color: #F4F3F1;
    padding: 10px 15px;
    border-radius: 15px;
  }
  
  &.closed {
    opacity: .75;
  }
  
  @media${PHONELG} {
    .closed & {
      padding: 15px 25px;
    }
  }
  
  @media${LAPTOP} {
    .closed & {
      padding: 25px 30px;
    }
  }
`;

const QuestionImage = styled.div`
  display: none;
  
  .closed & {
    .img-wrapper img {
      filter: grayscale(100%);
      opacity: .5;
    }
  }
  
  .img-wrapper {
    width: 100%;
    position: relative;
    padding-bottom: 65%;
    height: 0;
    border-radius: 10px;
    overflow: hidden;
    
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  @media${PHONELG} {
    display: block;
    flex: 0 0 92px;
    margin-right: 15px;
  }
`;

const QuestionContent = styled.div`
  h3 {
    font-size: 16px;
    margin-bottom: 5px;
  }
  
  .closed & {
    h3 {
      color: #656579;
    }
  }
  
  @media${TABLET} {
    h3 {
      font-size: 18px;
    }
  }
  
  @media${LAPTOP} {
    h3 {
      font-size: 20px;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/discussion/discussion-topic-block.js